function getBangkokLocation(postcode, full_address = '') {
  let bangkok_postcodes = [
    '10110',
    '10600',
    '10510',
    '10230',
    '10900',
    '10150',
    '10210',
    '10400',
    '10300',
    '10170',
    '10170',
    '10140',
    '10600',
    '10700',
    '10600',
    '10240',
    '10250',
    '10150',
    '10220',
    '10230',
    '10120',
    '10160',
    '10800',
    '10260',
    '10150',
    '10700',
    '10500',
    '10230',
    '10240',
    '10330',
    '10110',
    '10120',
    '10500',
    '10330',
    '10400',
    '10250',
    '10100',
    '10400',
    '10260',
    '10200',
    '10160',
    '10510',
    '10120',
    '10400',
    '10140',
    '10520',
    '10230',
    '10310',
    '10110',
    '10250',
    '10240',
    '10250',
    '10100',
    '10120',
    '10220',
    '10160',
    '10530',
    '10210',
    '10310'
  ]

  let met_postcodes = [
    '11000',
    '11110',
    '11120',
    '11130',
    '11140',
    '11150',
    '12000',
    '12110',
    '12120',
    '12130',
    '12130',
    '12140',
    '12150',
    '12160',
    '12170',
    '10130',
    '10270',
    '10280',
    '10290',
    '10540',
    '10540',
    '10550',
    '10560'
  ]

  let remote_postcodes = [
    '20240',
    '20270',
    '20150',
    '20220',
    '20140',
    '20240',
    '20160',
    '20000',
    '20130',
    '20110',
    '20230',
    '20250',
    '20180',
    '20190',
    '21000',
    '21100',
    '21150',
    '21160',
    '21130',
    '21180',
    '21140',
    '24000',
    '25000',
    '22000',
    '27000',
    '50000',
    '50100',
    '50300',
    '50200',
    '51000',
    '51150',
    '57000',
    '57100',
    '65000',
    '65230',
    '64000',
    '64210',
    '64220',
    '66000',
    '66170',
    '60000',
    '60240',
    '61000',
    '52000',
    '52100',
    '52220',
    '53000',
    '67000',
    '67210',
    '67250',
    '54000',
    '62000',
    '63000',
    '63110',
    '40000',
    '40260',
    '41000',
    '41330',
    '39000',
    '43000',
    '43100',
    '30000',
    '30280',
    '30310',
    '32000',
    '31000',
    '45000',
    '46000',
    '44000',
    '35000',
    '34000',
    '34190',
    '34310',
    '33000',
    '37000',
    '47000',
    '47220',
    '47230',
    '48000',
    '49000',
    '36000',
    '36240',
    '42000',
    '42100',
    '72000',
    '72210',
    '72230',
    '17000',
    '15000',
    '15160',
    '15210',
    '16000',
    '14000',
    '13000',
    '18000',
    '26000',
    '73000',
    '73170',
    '73120',
    '73110',
    '73210',
    '74000',
    '74120',
    '74110',
    '74130',
    '76000',
    '76100',
    '75000',
    '71000',
    '71190',
    '70000',
    '77000',
    '77210',
    '77110',
    '84000',
    '84100',
    '84140',
    '84310',
    '84320',
    '84330',
    '90110',
    '90000',
    '83000',
    '83100',
    '83130',
    '80000',
    '86000',
    '81000',
    '82000',
    '92000',
    '91000',
    '93000',
    '85000'
  ]

  if (
    full_address &&
    ['20150', '21160'].includes(postcode.toString()) &&
    full_address.includes('เกาะ')
  ) {
    return 'OTHER'
  }

  if (bangkok_postcodes.includes(postcode.toString())) return 'BKK'
  else if (met_postcodes.includes(postcode.toString())) return 'MET'
  else if (remote_postcodes.includes(postcode.toString())) return 'REM'
  else return 'OTHER'
}

function calculateShippingPrice({ type, address, total }) {
  let rate = false
  if (type == 'express') {
    let postcode = null
    address = address ? address.trim() : ''
    try {
      postcode = address.match(/[ ][1-9]{1}[0-9]{4}$/)
      if (postcode.length > 0) {
        postcode = postcode[0].trim()
      } else {
        throw new Error('Many postcode')
      }
    } catch (error) {
      postcode = null
    }

    if (!postcode) return 'not_found_postcode'
    let location = getBangkokLocation(postcode, address)

    if (['BKK', 'MET'].includes(location)) {
      if (total >= 0.5 && total <= 12) rate = 190
      else if (total > 12 && total <= 29) rate = 240
      else if (total > 29 && total <= 35) rate = 265
      else rate = false
    } else {
      if (total >= 0.5 && total <= 14) rate = 270
      else if (total > 14 && total <= 24) rate = 360
      else if (total > 24 && total <= 34) rate = 380
      else if (total > 34 && total <= 35) rate = 0
      else rate = false
    }
  } else if (['hub', 'hub+msg'].includes(type)) {
    rate = total * 5
  } else {
    rate = 0
  }

  if (rate != false) rate = Math.round(rate)
  return rate
}

export { getBangkokLocation, calculateShippingPrice }



// WEBPACK FOOTER //
// ./src/nvbb.js